import { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";
import { Breadcrumbs, CommonSelect } from "components/Common/Common";
import ClientAttachments from "./ClientAttachments";
import { CLIENT_TYPE_KEYS, DOCUMENTS_FILTER_OPTIONS } from "config/constants";
import LoadingOverlay from "components/shared/LoadingOverlay";
import AddClientDocumentsModal from "components/Modals/AddClientDocumentsModal";
import { getClientBreadCrumbs } from "helpers/common";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { useGetClientDetailsQuery } from "store/services/client";

const ClientAttachmentsPage = () => {
    const navigate = useNavigate()
    const { clientId, clientType } = useParams()
    const [clientsDocumentModal, setClientsDocumentModal] = useState(false)
    const [filter, setFilter] = useState({ resource_type: "" })
    const [isDisabled, setIsDisabled] = useState(false)

    const {
        data: clientDetails,
        isLoading,
        isFetching,
        refetch,
    } = useGetClientDetailsQuery(
        { clientId, clientType },
        { refetchOnMountOrArgChange: true }
    );

    const breadcrumbItems = useMemo(() => getClientBreadCrumbs(clientId, clientType, clientDetails, "Documents"), [clientType, clientDetails, clientId]);

    const handleFilterChange = (field) => (e) => {
        setFilter(prev => ({
            ...prev,
            [field]: e?.value || ""
        }));
    };


    useEffect(() => {
        if (clientDetails?.status == "discharged" || clientDetails?.status == "inactive") {
            setIsDisabled(true);
        }
    }, [clientDetails])

    return isLoading ? <LoadingIndicator /> : (
        <>
            <AddClientDocumentsModal
                show={clientsDocumentModal}
                setShow={setClientsDocumentModal}
                clientId={clientId}
                refetch={refetch}
            />
            {isFetching && <LoadingOverlay />}
            <section
                className={`position-relative ClientDetail`}
            >
                <Container fluid>
                    <Row style={{ paddingLeft: '12px' }} className="pt-3">
                        <Col lg="6">
                            <Breadcrumbs themeBlueV2 items={breadcrumbItems} />
                        </Col>
                    </Row>
                    <div className="mt-4" style={{ paddingLeft: '12px', borderRadius: "4px" }}>

                        <Row className="justify-content-between align-items-end" >
                            <Col lg='5'>
                                <p className="twenty proxima-regular mb-0" style={{ color: "#000" }}>
                                    Documents
                                </p>
                            </Col>
                            <Col lg='7'>
                                <div className="d-flex gap-3 w-100 justify-content-end">
                                    <div className="w-100 reports-v2 d-flex justify-content-end classroom-conslutation">
                                        <div className="d-flex w-100 align-items-center gap-3">
                                            <label className="discharge-screen-label mb-0">Type</label>

                                            <CommonSelect
                                                placeholder={"Select"}
                                                option={DOCUMENTS_FILTER_OPTIONS}
                                                onChange={(e) => handleFilterChange("resource_type")(e)}
                                                value={DOCUMENTS_FILTER_OPTIONS.find(o => o.value === filter.resource_type)}
                                                isFilterV2
                                                styles={{
                                                    container: (provided) => ({
                                                        ...provided,
                                                        width: "100%",
                                                    }),
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <button
                                        style={{ width: '235px', backgroundColor: isDisabled && '#F0D2E7', color: isDisabled && 'white' }}
                                        onClick={() => setClientsDocumentModal(true)}
                                        type="button"
                                        className="d-flex align-items-center gap-2 justify-content-center discharge-screen"
                                        disabled={isDisabled}
                                    >
                                        Add Documents
                                    </button>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <div className="mt-2">
                        <ClientAttachments
                            filter={filter}
                            isPage={true}
                            onClick={() => setClientsDocumentModal(true)}
                            resources={clientDetails?.clientResources || []}
                            clientId={clientId}
                            refetch={refetch}
                            clientType={CLIENT_TYPE_KEYS.school}
                        />
                    </div>
                </Container>
            </section>
        </>
    );

};

export default ClientAttachmentsPage;